import React from 'react';
import AdminMissingMerchant from './admin-missing-merchant.component';
export default function MissingDocument() {
    return <AdminMissingMerchant />;
}
